/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Name_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Project Name" |
*
* @param {New_Project_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_name_placeholder = /** @type {((inputs?: New_Project_Name_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Name_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektname")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome del progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Название проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre del proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目名称")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクト名")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परियोजना का नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nome do projeto")
	return /** @type {LocalizedString} */ ("Project Name")
});